// test730
(730 && 0);
